import React from 'react';
import { forwardRef } from 'react';

import Divider from '../Divider';
import Stack from '../Stack';
import { DividerSeparatorProps } from './types';

export const DividerSeparator = forwardRef<HTMLDivElement, DividerSeparatorProps>(
  (props, forwardedRef) => {
    const { dividerProps, ...rest } = props;

    return <Stack ref={forwardedRef} divider={<Divider {...dividerProps} />} {...rest} />;
  },
);

export default React.memo(DividerSeparator);
